module.exports = __webpack_public_path__ + "static/media/tensorflow_logo.ce630e75.png";